import React from 'react';
import {SvgHoc} from "./SvgHoc";
import {motion} from "framer-motion";

function Sunny({width = '25px', height = '25px'}) {
    return (
        <>
            <svg version="1.1" id="Layer_1"
                 x="0px" y="0px"
                 width={width}
                 height={height}
                 viewBox="0 0 100 100" enableBackground="new 0 0 100 100">
                <g

                >
                    <motion.g
                        animate={{
                            rotate: 360,
                            scale: [1, 1.1, 1],
                            y: [0, -5, 0],
                            x: [0, -5, 0],
                        }}
                        transition={{
                            default: {
                                duration: 10,
                                repeat: 'loop'
                            },
                            rotate: {duration: 50, repeat: 'loop'}
                        }}
                    >

                        <polygon fill="#F29D00" points="58.482,31.412 62.019,24.903 65.557,31.412 	"/>
                        <polygon fill="#F29D00" points="64.649,31.076 70.41,26.712 71.087,34.194 	"/>
                        <polygon fill="#F29D00" points="69.963,33.518 77.031,33.158 73.791,39.838 	"/>
                        <polygon fill="#F29D00" points="73.271,38.434 79.847,41.21 74.295,45.87 	"/>
                        <polygon fill="#F29D00" points="74.57,44.201 79.2,49.884 72.251,51.302 	"/>
                        <polygon fill="#F29D00" points="50.915,47.469 44.768,43.746 50.878,39.955 	"/>
                        <polygon fill="#F29D00" points="54.198,52.643 47.122,52.663 50.644,46.145 	"/>
                        <polygon fill="#F29D00" points="50.667,40.435 47.499,33.715 54.563,34.161 	"/>
                        <polygon fill="#F29D00" points="53.338,34.769 53.183,27.256 59.386,30.87 	"/>
                        <polygon fill="#F29D00" points="64.228,55.462 60.651,61.322 57.661,55.102 	"/>
                        <polygon fill="#F29D00" points="58.717,54.975 53.173,58.732 52.882,51.755 	"/>
                        <polygon fill="#F29D00" points="69.29,53.504 68.494,60.436 63.24,56.237 	"/>
                        <polygon fill="#F29D00" points="72.809,49.879 74.637,56.587 68.253,54.914 	"/>
                        <path fill="#F1C600" d="M74.509,43.258c0,7.083-5.407,12.825-12.075,12.825c-6.669,0-12.075-5.742-12.075-12.825
		c0-4.879,2.566-9.122,6.343-11.29c1.705-0.979,3.658-1.535,5.732-1.535C69.103,30.433,74.509,36.175,74.509,43.258z"/>

                    </motion.g>
                    <motion.g
                        initial={{
                            opacity:0.8
                        }}
                        animate={{
                            opacity:1,
                            scale: [1, 1.1, 1],
                            y: [0, 5, 0],
                            x: [0, 5, 0],
                        }}
                        transition={{
                            default: {
                                duration: 10,
                                repeat: 'loop'
                            },
                        }}
                    >
                        <path fill="#217EBA" d="M53.162,44.172c-1.461,0-2.837,0.362-4.045,0.999c-1.653-3.708-5.649-6.326-10.318-6.326
			c-5.87,0-10.675,4.134-11.099,9.375c-0.859-0.237-1.764-0.366-2.7-0.366c-5.557,0-10.062,4.464-10.062,9.97
			s4.505,9.97,10.062,9.97c2.415,0,4.631-0.844,6.365-2.249c1.318,4.509,5.602,7.815,10.688,7.815
			c6.136,0,11.109-4.808,11.109-10.74c0-0.383-0.022-0.762-0.062-1.135c0.021,0,0.042,0.002,0.062,0.002
			c4.791,0,8.675-3.876,8.675-8.657S57.953,44.172,53.162,44.172z"/>
                        <path fill="#217EBA" d="M78.54,52.895c-1.121-0.026-2.183,0.228-3.119,0.696c-1.211-2.875-4.236-4.953-7.819-5.034
			c-4.504-0.104-8.254,2.984-8.662,6.998c-0.656-0.196-1.347-0.312-2.066-0.328c-4.263-0.097-7.79,3.248-7.875,7.473
			c-0.086,4.225,3.302,7.728,7.565,7.825c1.854,0.042,3.566-0.567,4.919-1.613c0.941,3.482,4.177,6.094,8.079,6.183
			c4.708,0.108,8.599-3.495,8.691-8.046c0.006-0.294-0.005-0.584-0.03-0.872c0.016,0,0.031,0.002,0.048,0.002
			c3.676,0.084,6.716-2.821,6.79-6.49C85.135,56.022,82.215,52.979,78.54,52.895z"/>
                        <g>
                            <path fill="#3B96D2" d="M50.901,65.109c0.086-4.224,3.611-7.57,7.876-7.473c0.717,0.016,1.41,0.132,2.066,0.328
				c0.406-4.014,4.157-7.101,8.661-6.998c3.583,0.082,6.608,2.159,7.818,5.034c0.937-0.467,1.999-0.721,3.12-0.695
				c1.725,0.039,3.284,0.73,4.444,1.831c-0.854-2.614-3.286-4.532-6.194-4.599c-1.122-0.025-2.183,0.229-3.119,0.696
				c-1.211-2.875-4.236-4.953-7.819-5.034c-4.504-0.104-8.255,2.984-8.662,6.998c-0.656-0.197-1.348-0.312-2.065-0.328
				c-4.264-0.098-7.79,3.248-7.875,7.472c-0.043,2.14,0.804,4.092,2.205,5.513C51.045,66.999,50.882,66.073,50.901,65.109z"/>
                            <path fill="#3B96D2" d="M63.386,71.322c-0.082,0.063-0.166,0.125-0.251,0.185c0.156,0.196,0.322,0.385,0.496,0.567
				C63.538,71.828,63.454,71.577,63.386,71.322z"/>
                        </g>
                        <path fill="#3B96D2" d="M15.713,61.01c0-5.506,4.505-9.97,10.062-9.97c0.936,0,1.84,0.13,2.7,0.366
			c0.423-5.24,5.229-9.374,11.098-9.374c4.671,0,8.666,2.617,10.319,6.326c1.207-0.637,2.584-0.999,4.045-0.999
			c3.509,0,6.529,2.08,7.895,5.07c-0.21-4.594-4.008-8.256-8.665-8.256c-1.461,0-2.837,0.362-4.045,0.999
			c-1.653-3.708-5.649-6.326-10.319-6.326c-5.869,0-10.674,4.134-11.099,9.375c-0.859-0.237-1.764-0.366-2.699-0.366
			c-5.557,0-10.062,4.464-10.062,9.97c0,1.383,0.284,2.699,0.798,3.897C15.724,61.485,15.713,61.249,15.713,61.01z"/>
                    </motion.g>
                </g>
            </svg>
        </>
    );
}

export default SvgHoc(Sunny);